export const GET_FEATURES_REQUEST = 'GET_FEATURES_REQUEST';
export const GET_FEATURES_SUCCESS = 'GET_FEATURES_SUCCESS';
export const GET_FEATURES_ERROR = 'GET_FEATURES_ERROR';
